import {Component, forwardRef, Injector, Input, OnInit} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {CustomObjectSearchModel} from "../custom-object-search.model";
import {
    MembershipTypeCustomObjectSearchPageComponent
} from "../custom-object-search-page/membership-type-custom-object-search-page.component";
import {CustomObjectSearchPageComponent} from "../custom-object-search-page/custom-object-search-page.component";
import {
    ProductLineCustomObjectSearchPageComponent
} from "../custom-object-search-page/product-line-custom-object-search-page.component";
import {
    InventoryCustomObjectSearchPageComponent
} from "../custom-object-search-page/inventory-custom-object-search-page.component";
import {
    OutletCustomObjectSearchPageComponent
} from "../custom-object-search-page/outlet-custom-object-search-page.component";
import {CustomObjectEditPageComponent} from "../custom-object-edit-page/custom-object-edit-page.component";
import {
    CustomObjectAssociationContext,
    CustomObjectTypeSearchModel
} from "../../custom-object-type/custom-object-type-search.model";
import {
    ProductLineCustomObjectEditPageComponent
} from "../custom-object-edit-page/product-line-custom-object-edit-page.component";
import {
    InventoryCustomObjectEditPageComponent
} from "../custom-object-edit-page/inventory-custom-object-edit-page.component";
import {OutletCustomObjectEditPageComponent} from "../custom-object-edit-page/outlet-custom-object-edit-page.component";
import {
    MembershipTypeCustomObjectEditPageComponent
} from "../custom-object-edit-page/membership-type-custom-object-edit-page.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";

const CUSTOM_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CustomObjectMultiSelectEditControlComponent),
    multi: true
};

@Component({
    selector: "wbo-custom-object-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        CUSTOM_VALUE_ACCESSOR,
        provideSearchModel(CustomObjectSearchModel)
    ]
})
export class CustomObjectMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<CustomObjectSearchModel> implements OnInit {
    @Input() productLineContext: boolean;
    @Input() inventoryContext: boolean;
    @Input() outletContext: boolean;
    @Input() membershipTypeContext: boolean;
    private _customObjectTypeId: number;
    private _excludeCustomObjectTypeId: number;

    constructor(model: CustomObjectSearchModel, injector: Injector) {
        super(model, injector, "customObjectId", "name");
    }

    override ngOnInit(): void {
        super.ngOnInit();
        if (this.productLineContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.PRODUCT_LINE;
            this.extendedSearchComponent = ProductLineCustomObjectSearchPageComponent;
            this.extendedEditComponent = ProductLineCustomObjectEditPageComponent;
        } else if (this.inventoryContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.INVENTORY;
            this.extendedSearchComponent = InventoryCustomObjectSearchPageComponent;
            this.extendedEditComponent = InventoryCustomObjectEditPageComponent;
        } else if (this.outletContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.OUTLET;
            this.extendedSearchComponent = OutletCustomObjectSearchPageComponent;
            this.extendedEditComponent = OutletCustomObjectEditPageComponent;
        } else if (this.membershipTypeContext) {
            this.model.filter[CustomObjectTypeSearchModel.CONTEXT_FILTER_NAME] = CustomObjectAssociationContext.MEMBERSHIP_TYPE;
            this.extendedSearchComponent = MembershipTypeCustomObjectSearchPageComponent;
            this.extendedEditComponent = MembershipTypeCustomObjectEditPageComponent;
        } else {
            this.extendedSearchComponent = CustomObjectSearchPageComponent;
            this.extendedEditComponent = CustomObjectEditPageComponent;
        }
    }

    get customObjectTypeId(): number {
        return this._customObjectTypeId;
    }

    @Input()
    set customObjectTypeId(value: number) {
        this._customObjectTypeId = value;
        this.model.filter["customObjectTypeId"] = this._customObjectTypeId;
        this.extendedSearchComponentParams = {customObjectTypeId: this._customObjectTypeId, excludeCustomObjectTypeId: this._excludeCustomObjectTypeId}
    }

    get excludeCustomObjectTypeId(): number {
        return this._excludeCustomObjectTypeId;
    }

    @Input()
    set excludeCustomObjectTypeId(value: number) {
        this._excludeCustomObjectTypeId = value;
        this.model.filter["excludeCustomObjectTypeId"] = this._excludeCustomObjectTypeId;
        this.extendedSearchComponentParams = {customObjectTypeId: this._customObjectTypeId, excludeCustomObjectTypeId: this._excludeCustomObjectTypeId}
    }
}
